/* eslint-disable react/prop-types */
import styles from './testimonies.module.scss';
import Quote from '../../components/Quotes/Quote';
import i18n from '../../configs/i18n';
import { useTranslation } from 'react-i18next';

const Testimonies = () => {
	const [t] = useTranslation();
	const userLang = i18n.language;
	return (
		<section id="testimonies" className={styles.container}>
			<div className={styles.content_wrapper}>
				<h2>
					<b>{t('section.testimonials.title')}</b>
				</h2>
					<div className={styles.quote_list}>

							<Quote
							quote={t('section.testimonials.description1')}
							authorName={t('section.testimonials.name')}
							authorPosition={t('section.testimonials.position1')}
							/>

							<Quote
							quote={t('section.testimonials.description2')}
							authorName={t('section.testimonials.name2')}
							authorPosition={t('section.testimonials.position2')}
							/>

							<Quote
							quote={t('section.testimonials.description3')}
							authorName={t('section.testimonials.name3')}
							authorPosition={t('section.testimonials.position3')}
							/>
							{userLang === 'es' ? (
								<>
								<Quote
							quote={t('section.testimonials.description4')}
							authorName={t('section.testimonials.name4')}
							authorPosition={t('section.testimonials.position4')}
							/>

							<Quote
							quote={t('section.testimonials.description5')}
							authorName={t('section.testimonials.name5')}
							authorPosition={t('section.testimonials.position5')}
							/>

							<Quote
							quote={t('section.testimonials.description6')}
							authorName={t('section.testimonials.name6')}
							authorPosition={t('section.testimonials.position6')}
							/>
								</>
							):(
								<>
								</>
							)}
					</div>
			</div>
		</section>
	);
};

export default Testimonies;